import React, { useState } from 'react'
import qrypto_code_genenator from "../../assets/images/contents/Qrypto_Generator.png"
import qrypto_offline_validation from "../../assets/images/contents/Qrypto_offline_validation.png"
import qrypto_pdf_generator from "../../assets/images/contents/Qrypto_PDF_Generator.png"
import Slider from 'react-slick'
import { DialogActions, DialogContent, IconButton, useMediaQuery } from '@mui/material'
import theme from '../../assets/themes/theme'
import { Close } from '@mui/icons-material'
import ReactPlayer from 'react-player'
import playVideoIcon from '../../assets/images/icons/playvideo-button.svg';
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import { CustomDialogVideo } from '../../components/StyledComponents'


const HomeSlider = () => {
    const isMatch = useMediaQuery(theme.breakpoints.down("slider"));

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMcode: true
    };

    const language = useSelector(selectLanguage)

    const [openVideo1, setOpenVideo1] = useState(false);
    const [openVideo2, setOpenVideo2] = useState(false);
    const [openVideo3, setOpenVideo3] = useState(false);
    const [openOneVideo, setOpenOneVideo] = useState(false);
    const [firstUrl, setFirstUrl] = useState('');
    const [secondUrl, setSecondUrl] = useState('');
    const [thirdUrl, setThirdUrl] = useState('');
    const [singleUrl, setSingleUrl] = useState('')

    const handleOpenOneVideo = (e) => {
        setSingleUrl(e.url);
        setOpenOneVideo(true)
    }

    const handleCloseOneVideo = () => {
        setOpenOneVideo(false)
    }

    const handleOpenVideo1 = (e) => {
        setOpenVideo1(true);
        setFirstUrl(e.url1);
    };

    const handleCloseVideo1 = () => {
        setOpenVideo1(false);

    };

    const handleOpenVideo2 = (e) => {
        setOpenVideo2(true);
        setSecondUrl(e.url2);

    };

    const handleCloseVideo2 = () => {
        setOpenVideo2(false);
    };

    const handleOpenVideo3 = (e) => {
        setOpenVideo3(true);
        setThirdUrl(e.url3);
    };

    const handleCloseVideo3 = () => {
        setOpenVideo3(false);
    };


    const sliderData = [
        {
            id: 1,
            image1: qrypto_code_genenator,
            description1: "Qrypto Code Generator",
            description1_vi: "Trình tạo mã Qrypto",
            url1: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Code-Generator.m4v",
            image2: qrypto_offline_validation,
            description2: "Qrypto Offline Validation Example",
            description2_vi: "Ví dụ xác thực ngoại tuyến Qrypto",
            url2: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Offline-Validation-Example.m4v",
            image3: qrypto_pdf_generator,
            description3: "Qrypto PDF Generation",
            description3_vi: "Tạo Qrypto PDF",
            url3: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-PDF-Generation.m4v"
        },
        {
            id: 2,
            image1: qrypto_offline_validation,
            description1: "Qrypto Offline Validation Example",
            description1_vi: "Ví dụ xác thực ngoại tuyến Qrypto",
            url1: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Offline-Validation-Example.m4v",
            image2: qrypto_pdf_generator,
            description2: "Qrypto PDF Generation",
            description2_vi: "Tạo Qrypto PDF",
            url2: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-PDF-Generation.m4v",
            image3: qrypto_code_genenator,
            description3: "Qrypto Code Generator",
            description3_vi: "Trình tạo mã Qrypto",
            url3: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Code-Generator.m4v"

        },
        {
            id: 3,
            image1: qrypto_pdf_generator,
            description1: "Qrypto PDF Generation",
            description1_vi: "Tạo Qrypto PDF",
            url1: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-PDF-Generation.m4v",
            image2: qrypto_code_genenator,
            description2: "Qrypto Code Generator",
            description2_vi: "Trình tạo mã Qrypto",
            url2: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Code-Generator.m4v",
            image3: qrypto_offline_validation,
            description3: "Qrypto Offline Validation Example",
            description3_vi: "Ví dụ xác thực ngoại tuyến Qrypto",
            url3: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Offline-Validation-Example.m4v"
        }
    ]

    const sliderDataSm = [
        {
            id: 1,
            image: qrypto_code_genenator,
            description: "Qrypto Code Generator",
            description_vi: "Trình tạo mã Qrypto",
            url: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Code-Generator.m4v"

        },
        {
            id: 2,
            image: qrypto_offline_validation,
            description: "Qrypto Offline Validation Example",
            description_vi: "Ví dụ xác thực ngoại tuyến Qrypto",
            url: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-Offline-Validation-Example.m4v"
        },
        {
            id: 3,
            image: qrypto_pdf_generator,
            description: "Qrypto PDF Generation",
            description_vi: "Tạo Qrypto PDF",
            url: "https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-PDF-Generation.m4v"
        }
    ]

    const CustomPopupVideo = (props) => {
        return (
            <div>
                <CustomDialogVideo open={props.open} onClose={props.handleClose} 
                >
                    <DialogActions>
                        <IconButton onClick={props.handleClose} >
                            <Close />
                        </IconButton>
                    </DialogActions>
                    <DialogContent className='video-popup'>
                        <ReactPlayer
                            url={props.url}
                            controls={true}
                            style={{ maxWidth: '100%' }}
                            playing={true}
                        />
                    </DialogContent>
                </CustomDialogVideo>
            </div>
        )
    }


    return (
        <div className='home-slider col-sm-12'>
            {!isMatch ?
                <Slider {...settings}>
                    {sliderData.map((s) => (
                        <div key={s.id}>
                            <div className='home-slider_item'>
                                <div className='col-sm-4'>
                                    <div className='relative'>
                                        <IconButton className='img-center-button' disableRipple style={{ padding: 0 }} onClick={e => handleOpenVideo1(s)}>
                                            <img src={playVideoIcon} alt="" className='icon-60' />
                                        </IconButton>
                                        <img src={s.image1} alt={s.description1} className='client-s-350' />
                                        <CustomPopupVideo open={openVideo1} handleClose={handleCloseVideo1} url={firstUrl} />
                                    </div>
                                    {language === "en" ?
                                        <p className='text-white text-center pt-10'>{s.description1}</p>
                                        :
                                        <p className='text-white text-center pt-10'>{s.description1_vi}</p>
                                    }

                                </div>
                                <div className='col-sm-4'>
                                    <div className='relative'>
                                        <IconButton className='img-center-button' disableRipple style={{ padding: 0 }} onClick={e => handleOpenVideo2(s)}>
                                            <img src={playVideoIcon} alt="" className='icon-60' />
                                        </IconButton>
                                        <img src={s.image2} alt={s.description2} className='client-s-350' />
                                        <CustomPopupVideo open={openVideo2} handleClose={handleCloseVideo2} url={secondUrl} />
                                    </div>
                                    {language === "en" ?
                                        <p className='text-white text-center pt-10'>{s.description2}</p>
                                        :
                                        <p className='text-white text-center pt-10'>{s.description2_vi}</p>
                                    }
                                </div>
                                <div className='col-sm-4'>
                                    <div className='relative'>
                                        <IconButton className='img-center-button' disableRipple style={{ padding: 0 }} onClick={e => handleOpenVideo3(s)}>
                                            <img src={playVideoIcon} alt="" className='icon-60' />
                                        </IconButton>
                                        <img src={s.image3} alt={s.description3} className='client-s-350' />
                                        <CustomPopupVideo open={openVideo3} handleClose={handleCloseVideo3} url={thirdUrl} />
                                    </div>
                                    {language === "en" ?
                                        <p className='text-white text-center pt-10'>{s.description3}</p>
                                        :
                                        <p className='text-white text-center pt-10'>{s.description3_vi}</p>
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                :
                <Slider {...settings}>
                    {sliderDataSm.map((s) => (
                        <div className="home-slider_item" key={s.id}>
                            <div className='col-sm-12'>
                                <div className='relative'>
                                    <IconButton className='img-center-button' disableRipple style={{ padding: 0 }} onClick={e => handleOpenOneVideo(s)}>
                                        <img src={playVideoIcon} alt="" />
                                    </IconButton>
                                    <img src={s.image} alt={s.description} className='img-responsive' />
                                </div>
                                {language === "en" ?
                                    <p className='text-white text-center pt-10'>{s.description}</p>
                                    :
                                    <p className='text-white text-center pt-10'>{s.description_vi}</p>
                                }
                            </div>
                            <CustomPopupVideo open={openOneVideo} handleClose={handleCloseOneVideo} url={singleUrl} />
                        </div>
                    ))}
                </Slider>
            }


        </div>
    )
}

export default HomeSlider